import "./ArrayBundle.css";
import "../Bundle.css";
import { Link } from "react-router-dom";
import React from "react";

class ArrayBundle extends React.Component {
	componentDidMount() {
		document.title = "Array Bundle | CSCult's Gamified CP";
		window.scrollTo(0,0);
	}

	render() {
		return (
			<main style={{ margin: "1rem 12rem" }}>
				<h1 style={{textAlign: 'center', fontFamily: 'Gilroy', textDecoration: 'underline'}}><Link to="/">Go to Home</Link></h1>
				<div className="bundle-intro-container">
					<h1>Introduction to Arrays</h1>
					<p>
						<b>Array</b> is a data structure that contains a group
						of elements. Typically these elements are all of the
						same data type, such as an integer <code>(int)</code> or
						string <code>(str)</code>. Arrays are commonly used in
						computer programs to organize data so that a related set
						of values can be easily sorted or searched.
					</p>
					<p>
						Arrays are used to implement other data structures, such
						as lists, heaps, hash tables, deques, queues, stacks,
						strings, and Lists. Array-based implementations of other
						data structures are frequently simple and{" "}
						<b>space-efficient (implicit data structures)</b>,
						requiring little space overhead, but may have poor space
						complexity, particularly when modified, compared to
						tree-based data structures (compare a sorted array to a
						search tree).
					</p>
					<img src="https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fmedia.giphy.com%2Fmedia%2F60rrOIi2ZURBKymZ9y%2Fgiphy.gif&f=1&nofb=1" />
					<span>Cube representing a 3D array</span>
					<p>
						When data objects are stored in an array, individual
						objects are selected by an index that is usually a
						non-negative scalar integer. Indexes are also called{" "}
						<b>subscripts</b>. An index "maps" the array value to a
						stored object.
						<br />
						<br />
						Arrays can have multiple dimensions, thus it is not
						uncommon to access an array using multiple indices.{" "}
						<br />
						<br />
						As you can see above, this cube represents an array of
						multiple dimensions, in this case, <b>three</b>. An
						array representing this cube-like matrix can be declared
						as follows: <br />
						<br />
						<code style={{ fontSize: "2rem" }}>
							int arr[3][3][3];
						</code>
					</p>
				</div>
				<br />
				<br />
				<br />
				<h1
					style={{
						marginLeft: "4rem",
						marginBottom: "3rem",
						color: "white",
						fontFamily: "Poppins",
						fontWeight: "700",
						fontSize: "4rem",
					}}
				>
					More on arrays...
				</h1>
				<div className="bundle-games">
					<div className="bundle-game">
						<Link to="/games/arrays/accessing" id="accessing-div">
							Accessing
						</Link>
						<p>
							Accessing an array is a very important concept in
							array problems. In order to understand accessing,
							also known as indexing, we must understand memory
							allocation for arrays. Head on over to the{" "}
							<b>Accessing</b> Bundle Game to learn more.
						</p>
					</div>
					<div className="bundle-game">
						<p>
							Have you considered what happens when our computer
							either manipulates an array by adding or removing
							elements or retrieves elements from an array? You
							can understand it by going through the{" "}
							<b>Addressing</b> Bundle Game.
						</p>
						<Link to="/games/arrays/addressing" id="addressing-div">
							Addressing
						</Link>
					</div>
					<div className="bundle-game">
						<Link to="/games/arrays/rotation" id="rotation-div">
							Rotation
						</Link>
						<p>
							Rotation of arrays is something that is very crucial
							in conceptualizing, as it's very basis is used in
							many interview problems, especially in XOR-based
							problems. Circle through the <b>Rotation</b> Bundle
							Game.
						</p>
					</div>
					<div className="bundle-game">
						<p>
							How much time does it take to perform insertion of
							elements into an already existing array? Constant,
							linear or something else? Find out by going to the{" "}
							<b>Insertion</b> Bundle Game.
						</p>
						<Link to="/games/arrays/insertion" id="insertion-div">
							Insertion
						</Link>
					</div>
					<div className="bundle-game">
						<Link to="/games/arrays/updation" id="updation-div">
							Updation
						</Link>
						<p>
							Updating information is very important in everyday
							life. Especially in simple data structures like
							arrays! Let's head over to the <b>Updation</b>{" "}
							Bundle Game.
						</p>
					</div>
					<div className="bundle-game">
						<p>
							Every thing has a beginning and an end. So we gotta
							delete some elements from our array. How do we do
							that? Find out in the <b>Deletion</b> Bundle Game.
						</p>
						<Link to="/games/arrays/deletion" id="deletion-div">
							Deletion
						</Link>
					</div>
				</div>
			</main>
		);
	}
}

export default ArrayBundle;
